/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMarketActivity.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/market-activity";

export class AutogenModelMarketActivity<RowType extends ModelRow> extends Endpoint<RowType, RowMarketActivityFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMarketActivity extends ModelRow<RowMarketActivityFields> {
	constructor(values?: Partial<RowMarketActivityFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMarketActivityFields {
	allow_auto_date: string;
	assigned_user_id: string;
	company_id: string;
	days: number;
	def_assign: string;
	descr: string;
	id: string;
	info_packet_id: string;
	next_id: string;
	type_of: string;
}

